<template>
    <div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Ocorrências</h5>
                <hr>
                <TabView>					
      				<TabPanel header="Cadastro" class="p-mt-3">
						<NovaOcorrencia/>						
      				</TabPanel>
                    <TabPanel header="Lista" class="p-mt-3">
						<ListaOcorrencias/>
      				</TabPanel>
                </TabView>
			</div>
		</div>
    </div>
</template>

<script>
import NovaOcorrencia from '@/components/pages/movimento/ocorrencias/NovaOcorrencia.vue';
import ListaOcorrencias from '@/components/pages/movimento/ocorrencias/ListaOcorrencias.vue';

export default {	
	components: {
		'ListaOcorrencias': ListaOcorrencias,
		'NovaOcorrencia': NovaOcorrencia,
    }
}
</script>

<style>

</style>